import styled, { css } from 'styled-components';

import { Icon } from 'core/components/Icon/Icon.style';
import * as vr from 'core/styles/variables';

export const BPAYWrapper = styled.div<{
	isDashboardModule: boolean;
}>`
	display: flex;
	align-items: center;
	width: 100%;
	${({ isDashboardModule }) =>
		isDashboardModule &&
		css`
			${Icon} {
				border: 6px solid white;
				border-radius: 6px;
			}
		`}
	${({ isDashboardModule, theme }) =>
		css`
			${Icon} {
				width: ${isDashboardModule ? '84' : '42'}px;
				height: ${isDashboardModule ? '124' : '64'}px;
				flex-shrink: 0;
				color: ${isDashboardModule
					? `${theme.core.getCompositionColor('blue-lighter')}`
					: `${vr.bpayLogo}`};
				background-color: white;
			}
		`}
`;

export const BPAYInfo = styled.div`
	padding-left: 16px;

	> div {
		width: 100%;
	}
`;
